import React from 'react';
import Modal from '@common/modal';

import classnames from 'classnames/bind';
import styles from './pageCloseModal.module.scss';
const cx = classnames.bind(styles);

interface KeywordModalProps {
  visible: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const PageCloseModal = ({ visible, onCancel, onConfirm }: KeywordModalProps) => {
  return (
    <Modal visible={visible}>
      <div className={cx('layer')}>
        <strong className={cx('title')}>페이지를 닫으시겠어요?</strong>
        <p className={cx('desc')}>저장되지 않은 정보는 사라집니다.</p>
        <div className={cx('btnArea')}>
          <a className={cx('btn', 'cancel')} role="button" onClick={onCancel}>
            취소
          </a>
          <a className={cx('btn', 'confirm')} role="button" onClick={onConfirm}>
            닫기
          </a>
        </div>
      </div>
    </Modal>
  );
};

export default PageCloseModal;
